import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import { boolean, object } from 'yup';
import { BankIDInputMeta, CorporateNameInputMeta } from '../../commonMeta';

export interface IBankAccountRoutingFormMeta {
  bankID: FormInputMeta;
  corporateName: FormInputMeta;
  transactionCurrency: FormInputMeta;
  transactionCode: FormInputMeta;

  schema: any;
}

const bankAccountRoutingFormMeta = {} as IBankAccountRoutingFormMeta;

bankAccountRoutingFormMeta.bankID = BankIDInputMeta;

bankAccountRoutingFormMeta.corporateName = CorporateNameInputMeta;

bankAccountRoutingFormMeta.transactionCurrency = {
    name: "transactionCurrency",
    label: "",
    type: "checkbox",
    validation: boolean().required("Transaction Currency is Required"),
}

bankAccountRoutingFormMeta.transactionCode = {
    name: "transactionCode",
    label: "",
    type: "checkbox",
    validation: boolean().required("Transaction Code is Required"),
}

bankAccountRoutingFormMeta.schema = object().shape(getValidationSchema(bankAccountRoutingFormMeta));

export default bankAccountRoutingFormMeta;